define('gigaset_stocknotification/components/product/view',[
	"jquery",
	"lodash",
	"cartware/components/_base",
	"cartware/jquery/bem",
	"gigaset/spinner",
	"text!shoptheme/templates/magnific-popup/default.html",
	"json2"
], function(
	$,
	_,
	Component,
	BEM,
	Spinner,
	PopupHtml
) {
	var popup = null;

	return Component.create({
		watchlistDialog:		null,
		emailInput:				null,
		attributeInput:			null,
		productIdInput:			null,
		parentProductId:		null,
		bundledOptions:			null,
		addToCart:				null,
		submitting:				false,

		constructor: function() {
			this.bundledOptions = [];
		},

		$init: function() {
			this.addToCart = BEM.block("product-detail-add-to-cart");
			this.watchlistDialog = BEM.block("product-stocknotification");
			this.emailInput = this.watchlistDialog.getElements("input");
			this.attributeInput = $('.watchlist-attributes');
			this.productIdInput = $('.watchlist-product-id');
			this.parentProductId = $('.watchlist-parent-product-id');
			this.cartButton = $('.btn-cart');
			this.addToBox = $('.add-to-box');
			this.isCatalogStore = this.watchlistDialog.data("is-catalog-store");

			this.watchlistDialog.insertBefore(this.addToBox);

			$(document).on("product/changeSimple", $.proxy(this._onSimpleChange, this));
			var bundle = window.bundle;
			var opConfig = window.opConfig;
			var self = this;

			if (opConfig) {
				opConfig.reloadPrice = function() {
					var config = this.config;
					var skipIds = [];
					var self = this;
					this.selectedOptions = [];
					$$('body .product-custom-option').each(function(element){
						var optionId = 0;
						element.name.sub(/[0-9]+/, function(match){
							optionId = parseInt(match[0], 10);
						});
						if (config[optionId]) {
							var configOptions = config[optionId];
							var curConfig = {price: 0};
							if (element.type == 'checkbox' || element.type == 'radio') {
								if (element.checked) {
									if (typeof configOptions[element.getValue()] != 'undefined') {
										curConfig = configOptions[element.getValue()];

										if (!self.selectedOptions[optionId]) {
											self.selectedOptions[optionId] = [];
										}

										self.selectedOptions[optionId].push(element.getValue());
									}
								}
							} else if(element.hasClassName('datetime-picker') && !skipIds.include(optionId)) {
								dateSelected = true;
								$$('.product-custom-option[id^="options_' + optionId + '"]').each(function(dt){
									if (dt.getValue() == '') {
										dateSelected = false;
									}
								});
								if (dateSelected) {
									curConfig = configOptions;
									skipIds[optionId] = optionId;
								}
							} else if(element.type == 'select-one' || element.type == 'select-multiple') {
								if ('options' in element) {
									$A(element.options).each(function(selectOption){
										if ('selected' in selectOption && selectOption.selected) {
											if (typeof(configOptions[selectOption.value]) != 'undefined') {
												curConfig = configOptions[selectOption.value];

												if (!self.selectedOptions[optionId]) {
													self.selectedOptions[optionId] = [];
												}

												self.selectedOptions[optionId].push(selectOption.value);
											}
										}
									});
								}
							} else {
								if (element.getValue().strip() != '') {
									curConfig = configOptions;
								}
							}
							if(element.type == 'select-multiple' && ('options' in element)) {
								$A(element.options).each(function(selectOption) {
									if (('selected' in selectOption) && typeof(configOptions[selectOption.value]) != 'undefined') {
										if (selectOption.selected) {
											curConfig = configOptions[selectOption.value];
										} else {
											curConfig = {price: 0};
										}
										optionsPrice.addCustomPrices(optionId + '-' + selectOption.value, curConfig);
										optionsPrice.reload();
									}
								});
							} else {
								optionsPrice.addCustomPrices(element.id || optionId, curConfig);
								optionsPrice.reload();
							}
						}
					});
				};
			}

			if (bundle) {
				this.isBundleAvailable(bundle);

				var oldChangeSelection = bundle.changeSelection;
				bundle.changeSelection = function (o) {
					oldChangeSelection.apply(bundle, arguments);

					self.isBundleAvailable(bundle);

					//_.forEach(bundle.config.selected, function(value, key) {
					//	console.log(key);
					//	console.log(value);
					//});
				}
			}

			this.watchlistDialog.getElements("submit").on("click", _.bind(this.submit, this));
			this.emailInput.on("keypress", function(e) {
				if (e.charCode == 13) {
					e.preventDefault();
					self.submit();
				}
			});
		},

		submit: function(e) {
			var self = this;

			if (e) {
				e.preventDefault();
			}

			if (this.submitting) return;

			if (!Validation.validate(this.emailInput.get(0))) {
				return;
			}

			var form = $("<form>");

			form
				.css("display", "none")
				.attr("action", this.watchlistDialog.data("action"))
				.attr("method", "POST")
				.appendTo(document.body);

			if (window.bundle) {
				this.attributeInput.val(JSON.stringify({
					bundle_option: window.bundle.config.selected,
					options: window.opConfig ? window.opConfig.selectedOptions : []
				}));
			}

			this.watchlistDialog.clone().appendTo(form);

			Spinner.add();

			this.submitting = true;

			$.ajax(form.attr("action"), {
				method: form.attr("method"),
				data: form.serialize(),
				dataType: "json"
			}).then(function (res) {
				var content = res.message;

				if ("error" in res) {
					content = res.error;
				}

				$.magnificPopup.open({
					items: {
						src: self._renderPopup({
							body: content
						})
					}
				});

				Spinner.remove();

				self.submitting = false;
			});
		},

		_onSimpleChange: function(e, simple) {
			if (this.isCatalogStore || (simple && (simple.qty <= 0 || !simple.is_available))) {
				var attributes = {};

				this.watchlistDialog.insertAfter(this.addToCart);
				this.watchlistDialog.show();
				this.addToCart.hide();

				$.each(simple.attributes, function (index, value) {
					attributes[value.attributeId] = value.value;
				});

				this.attributeInput.val(JSON.stringify({super_attribute: attributes}));
				this.productIdInput.val(simple.id);
			} else {
				this.watchlistDialog.hide();
				this.addToCart.show();

				this.attributeInput.val('');
				this.productIdInput.val(this.parentProductId.val());
			}
		},

		isBundleAvailable: function (bundle) {
			var available = true,
				display = this.watchlistDialog.is(':visible');

			_.forEach(bundle.config.selected, function(value, key) {
				var optionId = key;

				_.forEach(value, function(value, key) {
					if (!bundle.config.options[optionId].selections[value]['available']) {
						available = false;
					}
				});
			});

			if (!available) {
				this.watchlistDialog.insertAfter(this.addToCart);
				this.watchlistDialog.show();
				this.addToCart.hide();
				this.cartButton.attr('disabled', 'disabled');
			} else {
				this.watchlistDialog.hide();
				this.addToCart.show();
				this.cartButton.removeAttr('disabled');
			}
		},

		_renderPopup: function(data) {
			if (null === popup) {
				popup = _.template(PopupHtml);
			}

			return popup(data);
		}
	});
});

